<template>
	<div @dblclick="onDblClick()" v-on-clickaway="hideToolbar">
		<quill-editor v-model="value"
			:options="editorOption"
			ref="myQuillEditor"
			:id="id"
			:key="id"
			:instanceName="id">
			<div :id="`toolbar-${id}`" class="toolbar" :style="{display : display}" slot="toolbar">
			<span class="ql-formats">
				<select class="ql-font"></select>
				<select class="ql-size"></select>
			</span>
			<span class="ql-formats">
				<button class="ql-bold"></button>
				<button class="ql-italic"></button>
				<button class="ql-underline"></button>
				<button class="ql-strike"></button>
			</span>
			<span class="ql-formats">
				<select class="ql-color"></select>
				<select class="ql-background"></select>
			</span>
			<span class="ql-formats">
				<button class="ql-list" value="ordered"></button>
				<button class="ql-list" value="bullet"></button>
				<button class="ql-indent" value="-1"></button>
				<button class="ql-indent" value="+1"></button>
			</span>
			<span class="ql-formats">
				<button class="ql-direction" value="rtl"></button>
				<select class="ql-align"></select>
			</span>
			<span class="ql-formats">
				<button class="ql-link"></button>
				<button class="ql-image"></button>
			</span>
			<span class="ql-formats">
				<button class="ql-clean"></button>
			</span>
		</div>
		</quill-editor>
	</div>
</template>

<script scoped>
	import { quillEditor } from 'vue-quill-editor';
	import { directive as onClickaway } from 'vue-clickaway';
	export default {
		props: ['id', 'data'],
		components: {
			quillEditor
		},
		directives: {
			onClickaway: onClickaway
		},
		data () {
			return {
				value: this.data,
				editorOption: {
					modules: {
						toolbar : '#toolbar-'+this.$props.id
					},
					bounds: '.ql-snow'
				},
				display: 'none'
	  		}
		},
		methods: {
			onDblClick() {
				this.display = 'block';
				this.editor.enable();
			},
	  		hideToolbar() {
		  		this.display = 'none';
		  		this.editor.enable(false);
	  		},
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		watch: {
			value(val) {
				let payload = {
					id: this.id,
					text: val
				};
				this.$store.commit('reports/SET_TEXT_VALUE', payload);
			}
		},
		mounted() {
	  		this.editor.enable(false);
		}
  	}
</script>

<style scoped>
	.ql-container.ql-snow {
		border: 0px;
	}
	.ql-toolbar.ql-snow {
		position: absolute;
		margin-top: -37px;
		margin-left: -11px;
		min-width: 800px;
		width: auto;
		padding: 0px;
		z-index: 1;
		font-family: "Graphik";
		background-color: #ffffff;
		border: none;
		border-radius: 3px;
		box-shadow: 0 2px 8px 0 rgba(0,0,0,0.3);
	}
	.ql-editor {
		padding-top: 0;
	}
</style>